export default "__VITE_ASSET__g6BPFi_C__"